const ITEMS = [
  "MILLBERRY", "BERRY / CANDY", "BIRCH / CLIFF", "6063 EXTRUSION", "ZORBA",
  "LME", "COMEX", "SME", "HS 7601", "HS 7604", "HS 7404",
  "QINGDAO — ISTANBUL", "ZERO-COST COLLARS", "MTM P&L",
];

export default function Marquee() {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
      {ITEMS.map((item) => (
        <span key={`${item}-${ariaHidden}`} className="flex items-center">
          <span className="font-display font-bold text-lg sm:text-xl tracking-wide text-[#64748B] px-8 whitespace-nowrap hover:text-[#F07D38] transition-colors duration-300">
            {item}
          </span>
          <span className="w-2 h-2 rotate-45 bg-[#E06D28]/70 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative border-y border-[#283244] bg-[#111620]/60 py-6 overflow-hidden">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
